import MainMenuHeader, { MainMenuHeaderProps } from './MainMenuHeader';

export type { MainMenuHeaderProps };
export default MainMenuHeader;
